export default __webpack_public_path__ + "static/brush-large-11f413006f426386f5b4ed755ffcb913.png";